import { json2csv_fn, toThousands, getExportName_fn, weekLocaleArray } from "@/utils/common";
import locale from "@/helpers/locale";
import moment from "moment";


function currencyFormat(value) {
  return value !== null && value !== undefined ? "¥" + toThousands(value) : "";
}

export function exportCSV_fn(datas, startDate, endDate) {
  let csvData = [];
  const fields = [
    {
      label: locale("global.sort"),
      value: "sort",
    },
    {
      label: locale("global.cinemaName"),
      value: "cinemaName",
    },
    {
      label: `${locale("report.onlineReservation.online")}>${locale("operation.NAT.qty")}`,
      value: "commissionFees_visitor",
    },
    {
      label: `${locale("report.onlineReservation.online")}>${locale("accountPayable.income")}`,
      value: "commissionFees_total",
    },
    {
      label: `${locale("report.onlineReservation.online")}>${locale("dailyDetail.seatNumber")}`,
      value: "commissionFees_seatVisitor",
    },
    {
      label: `${locale("report.onlineReservation.online")}>${locale("dailyDetail.seatSales")}`,
      value: "commissionFees_seatTotal",
    },
    {
      label: `${locale("report.onlineReservation.online")}>${locale("report.onlineReservation.salesTotal")}`,
      value: "commissionFees_allTotal",
    },
    {
      label: `${locale("report.onlineReservation.online")}>${locale("report.onlineReservation.systemUseFee(excluding tax)")}`,
      value: "commissionFees_allTotalFee",
    },
    {
      label: `${locale("report.onlineReservation.PG")}>${locale("report.onlineReservation.salesProcessed")}>${locale("report.onlineReservation.transactionNumber")}`,
      value: "completedSales_allTotal",
    },
    {
      label: `${locale("report.onlineReservation.PG")}>${locale("report.onlineReservation.salesProcessed")}>${locale("report.salesProcessed")}`,
      value: "completedSales_salesTotal",
    },
    {
      label: `${locale("report.onlineReservation.PG")}>${locale("report.onlineReservation.cancellationsProcessed")}>${locale("report.onlineReservation.transactionNumber")}`,
      value: "refundedSales_allTotal",
    },
    {
      label: `${locale("report.onlineReservation.PG")}>${locale("report.onlineReservation.cancellationsProcessed")}>${locale("report.salesProcessed")}`,
      value: "refundedSales_salesTotal",
    },
    {
      label: `${locale("report.onlineReservation.PG")}>${locale("report.allSales")}>${locale("report.allSales.allTotal")}`,
      value: "allSales_allTotal",
    },
    {
      label: `${locale("report.onlineReservation.PG")}>${locale("report.allSales")}>${locale("report.allSales.salesTotal")}`,
      value: "allSales_salesTotal",
    },
    {
      label: `${locale("report.onlineReservation.PG")}>${locale("report.allSales")}>${locale("report.allSales.allTotalFee")}`,
      value: "allSales_allTotalFee",
    },
    {
      label: `${locale("report.onlineReservation.PG")}>${locale("report.allSales")}>${locale("report.allSales.salesTotalFee")}`,
      value: "allSales_salesTotalFee",
    },
    {
      label: `${locale("report.onlineReservation.PG")}>${locale("report.onlineReservation.processingTotal")}`,
      value: "total",
    },
    {
      label: `${locale("report.onlineReservation.card")}>VISA/MASTER`,
      value: "vmCardTotal",
    },
    {
      label: `${locale("report.onlineReservation.card")}>JCB/AMEX/Diners`,
      value: "jadCardTotal",
    },
    {
      label: `${locale("report.onlineReservation.card")}>PayPay`,
      value: "paypayTotal",
    },
    {
      label: `${locale("report.onlineReservation.card")}>クレジットカード決済手数料(税抜)>VISA/MASTER`,
      value: "vmCardTotalFee",
    },
    {
      label: `${locale("report.onlineReservation.card")}>クレジットカード決済手数料(税抜)>JCB/AMEX/Diners`,
      value: "jadCardTotalFee",
    },
    {
      label: `${locale("report.onlineReservation.card")}>PayPay決済手数料(税抜)`,
      value: "paypayTotalFee",
    },
    {
      label: `${locale("report.onlineReservation.card")}>${locale("report.onlineReservation.totalAmount")}`,
      value: "cardTotal",
    },
    {
      label: `${locale("report.onlineReservation.total")}>${locale("operation.NAT.qty")}`,
      value: "boxOfficelateShow_visitorTotal",
    },
    {
      label: `${locale("report.onlineReservation.total")}>${locale("global.amount")}`,
      value: "boxOfficelateShow_total",
    },
    {
      label: `${locale("report.onlineReservation.advanceTicket")}>${locale("operation.NAT.qty")}`,
      value: "advanceTicket_visitor",
    },
    {
      label: `${locale("report.onlineReservation.advanceTicket")}>${locale("global.amount")}`,
      value: "advanceTicket_total",
    },
    {
      label: `${locale("report.onlineReservation.nationTicket")}>${locale("operation.NAT.qty")}`,
      value: "nationalTicket_visitor",
    },
    {
      label: `${locale("report.onlineReservation.nationTicket")}>${locale("global.amount")}`,
      value: "nationalTicket_total",
    },
    {
      label: `${locale("report.onlineReservation.totalAmount")}`,
      value: "ticket_total",
    },
    {
      label: "ネット仮押チケット>支払前",
      value: "freeHoldSeatPendingCount",
    },
    {
      label: "ネット仮押チケット>支払済み",
      value: "freeHoldSeatPayedCount",
    },
    {
      label: "ネット仮押チケット>支払済み枚数",
      value: "freeHoldSeatPayedFee",
    }
  ];
  const hasVisibleData = (qtyKey, amountKey) => {
    return datas.some(item => {
      const hasKeys = item[qtyKey] !== undefined &&
        item[qtyKey] !== null &&
        item[amountKey] !== undefined &&
        item[amountKey] !== null;
      if (!hasKeys) { return false; }
      const qty = Number(item[qtyKey]);
      const amount = Number(item[amountKey]);
      return qty !== 0 || amount !== 0;
    });
  };
  const dynamicTicketColumns = [];
  if (hasVisibleData("boxOffice_visitor", "boxOffice_total")) {
    dynamicTicketColumns.push(
      {
        label: `${locale("report.onlineReservation.bookPerformance")}>${locale("operation.NAT.qty")}`,
        value: "boxOffice_visitor",
      },
      {
        label: `${locale("report.onlineReservation.bookPerformance")}>${locale("global.amount")}`,
        value: "boxOffice_total",
      }
    );
  }
  if (hasVisibleData("morningShow_visitor", "morningShow_total")) {
    dynamicTicketColumns.push(
      {
        label: `${locale("report.onlineReservation.morningShow")}>${locale("operation.NAT.qty")}`,
        value: "morningShow_visitor",
      },
      {
        label: `${locale("report.onlineReservation.morningShow")}>${locale("global.amount")}`,
        value: "morningShow_total",
      }
    );
  }
  if (hasVisibleData("lateShow_visitor", "lateShow_total")) {
    dynamicTicketColumns.push(
      {
        label: `${locale("report.onlineReservation.lateShow")}>${locale("operation.NAT.qty")}`,
        value: "lateShow_visitor",
      },
      {
        label: `${locale("report.onlineReservation.lateShow")}>${locale("global.amount")}`,
        value: "lateShow_total",
      }
    );
  }
  if (hasVisibleData("allNight_visitor", "allNight_total")) {
    dynamicTicketColumns.push(
      {
        label: `${locale("report.onlineReservation.allNight")}>${locale("operation.NAT.qty")}`,
        value: "allNight_visitor",
      },
      {
        label: `${locale("report.onlineReservation.allNight")}>${locale("global.amount")}`,
        value: "allNight_total",
      }
    );
  }
  if (hasVisibleData("specialBusiness_visitor", "specialBusiness_total")) {
    dynamicTicketColumns.push(
      {
        label: `${locale("report.onlineReservation.specialBusiness")}>${locale("operation.NAT.qty")}`,
        value: "specialBusiness_visitor",
      },
      {
        label: `${locale("report.onlineReservation.specialBusiness")}>${locale("global.amount")}`,
        value: "specialBusiness_total",
      }
    );
  }
  const insertAt = fields.findIndex(field => field.value === "boxOfficelateShow_visitorTotal");
  fields.splice(insertAt, 0, ...dynamicTicketColumns);
  if (datas.length > 0) {
    datas.forEach(item => {
      csvData.push({
        ...item,
        commissionFees_total: currencyFormat(item.commissionFees_total),
        commissionFees_seatTotal: currencyFormat(item.commissionFees_seatTotal),
        commissionFees_allTotal: currencyFormat(item.commissionFees_allTotal),
        commissionFees_allTotalFee: currencyFormat(item.commissionFees_allTotalFee),
        vmCardTotal: currencyFormat(item.vmCardTotal),
        jadCardTotal: currencyFormat(item.jadCardTotal),
        jadCardTotalFee: currencyFormat(item.jadCardTotalFee),
        vmCardTotalFee: currencyFormat(item.vmCardTotalFee),
        paypayTotal: currencyFormat(item.paypayTotal),
        paypayTotalFee: currencyFormat(item.paypayTotalFee),
        cardTotal: currencyFormat(item.cardTotal),
        boxOffice_total: currencyFormat(item.boxOffice_total),
        morningShow_total: currencyFormat(item.morningShow_total),
        lateShow_total: currencyFormat(item.lateShow_total),
        allNight_total: currencyFormat(item.allNight_total),
        specialBusiness_total: currencyFormat(item.specialBusiness_total),
        boxOfficelateShow_total: currencyFormat(item.boxOfficelateShow_total),
        advanceTicket_total: currencyFormat(item.advanceTicket_total),
        nationalTicket_total: currencyFormat(item.nationalTicket_total),
        ticket_total: currencyFormat(item.ticket_total),
      });
    });
    json2csv_fn(
      csvData, fields,
      getExportName_fn(
        locale("sideMenu.onlineReservationSalesReport"),
        "",
        "",
        "",
        `${moment(startDate).format("YYYY-MM-DD")} （${weekLocaleArray[moment(startDate).day()]}）~ ${moment(endDate).format("YYYY-MM-DD")} （${weekLocaleArray[moment(endDate).day()]}）`,
        moment().format("YYYYMMDDHHmm")
      )
    );
  }
}